import type { TranslationInterface } from '.';

export const ArabicLanguage: TranslationInterface = {
  write_a_message_placeholder: 'اكتب رسالة...',
  your_issue_has_been_resolved: 'تم حل مشكلتك!',
  new_conversation: 'محادثة جديدة',
  welcome_screen_title: 'مرحبًا بك في دردشة الدعم الخاصة بنا',
  welcome_screen_description:
    'نحن هنا للمساعدة! ابدأ محادثة وسنرد عليك في أقرب وقت ممكن.',
  your_name_placeholder: 'اسمك',
  your_email_placeholder: 'عنوان بريدك الإلكتروني',
  start_chat_button: 'تحدث إلى الدعم',
  start_chat_button_loading: 'جاري الاتصال...',
  i_need_more_help: 'أحتاج المزيد من المساعدة',
  this_was_helpful: 'كان هذا مفيدًا',
  optional: 'اختياري',
  no_conversations_yet: 'لا يوجد محادثات',
  back_to_conversations: 'العودة إلى المحادثات',
  closed_conversations: 'المحادثات المغلقة',
  csat_title: 'كيف كانت محادثتك؟',
  csat_submitted_title: 'لقد قيّمت المحادثة بـ',
  csat_feedback_placeholder: 'أخبرنا المزيد... (اختياري)',
  follow_up_placeholder: 'تابع المحادثة…',
  companion_layout_label: 'التخطيط',
  companion_layout_floating: 'عائم',
  companion_layout_sidebar: 'الشريط الجانبي',
  companion_layout_fullscreen: 'ملء الشاشة',
  companion_close_chat: 'إغلاق {title}',
  companion_close: 'إغلاق',
  companion_switch_chat: 'تبديل المحادثة',
  companion_viewing: 'تعرض الآن',
  companion_working: 'قيد العمل',
  companion_open: 'مفتوحة',
  companion_closed: 'مغلقة',
  companion_draft: 'مسودة',
  companion_chats: 'الجلسات النشطة',
  companion_chat_number: 'محادثة {count}',
  companion_active_chats: '{count} جلسات نشطة',
  companion_other_sessions: 'الجلسات المفتوحة الأخرى: {count}',
  companion_working_chats: '{count} قيد العمل',
  unread_sessions: '{count} غير مقروءة',
  companion_history: 'سجل المحادثات',
  companion_expand_chat: 'توسيع المحادثة',
  companion_sidebar_dock_label: 'الإرساء',
  companion_sidebar_side_label: 'الجانب',
  companion_sidebar_left: 'يسار',
  companion_sidebar_right: 'يمين',
  companion_resize_chat: 'تغيير حجم المحادثة',
  scroll_to_bottom: 'التمرير إلى الأسفل',
  thinking: 'جارٍ التفكير…',
  running: 'جارٍ التنفيذ…',
  steps: 'خطوات',
  step_arguments: 'الوسائط',
  step_result: 'النتيجة',
  attach_files:
    'إرفاق صور أو مقاطع فيديو أو ملفات PDF أو جداول بيانات (الحد الأقصى 25 ميغابايت)',
  mark_page_active: 'انقر على أي شيء في الصفحة لتحديده — اضغط Esc للإلغاء',
  mark_page: 'حدّد شيئًا في الصفحة لطرح سؤال عنه',
  stop_response: 'إيقاف الرد',
  copy_reply: 'نسخ الرد',
  mentions_empty: 'لا توجد نتائج',
  copied: 'تم النسخ',
  send_message: 'إرسال الرسالة',
  upload_failed: 'فشل الرفع: {error}',
  remove_attachment: 'إزالة المرفق',
  json_no_items: 'لا توجد عناصر',
  json_no_data: 'لا توجد بيانات',
  json_no_chart_data: 'لا توجد بيانات لعرضها في الرسم البياني',
  json_unsupported: 'غير مدعوم: {type}',
  json_see_less: 'عرض أقل',
  json_phone_agent: 'وكيل هاتفي',
  json_phone_agent_test: 'اختبار عبر الويب',
  page_context_remove: 'إزالة سياق الصفحة',
  json_see_more: 'عرض {count} إضافية',
  queued_label: '{count} في الانتظار',
  remove_queued_message: 'إزالة الرسالة من قائمة الانتظار',
  send_queued_now: 'إرسال الرسائل في قائمة الانتظار الآن',
  turn_failed_message: 'حدث خطأ ما ولم يصل الرد.',
  turn_failed_retry: 'حاول مرة أخرى',
  page_mark_hint: 'انقر على أي شيء لتحديده',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'مربع',
  page_mark_shape_circle: 'دائرة',
  page_mark_shape_arrow: 'سهم',
  page_mark_shape_bracket: 'قوس',
  page_mark_shape_underline: 'تسطير',
  page_mark_shape_highlight: 'تمييز',
  page_mark_shape_strike_through: 'شطب',
  page_mark_shape_crossed_off: 'علامة تقاطع',
  page_mark_shape_aria: 'شكل التحديد: {shape}',
  page_mark_note_placeholder: 'أضف ملاحظة… (Enter للإرفاق)',
  page_mark_attach: 'إرفاق التحديد',
  page_mark_remove: 'إزالة {label}',
  page_mark_region: 'منطقة محددة',
  page_mark_default_message: 'ما هذا؟',
  file_rejected: 'نوع الملف غير مدعوم أو أن الملف كبير جدًا.',
  dictate: 'إملاء صوتي',
  stop_dictation: 'إيقاف الإملاء',
  dictation_mic_blocked: 'اسمح بالوصول إلى الميكروفون للإملاء',
  dictation_unavailable: 'الإملاء غير متاح حاليًا',
  questions_back: 'رجوع',
  questions_next: 'التالي',
  questions_send: 'إرسال',
  questions_type_answer: 'سأكتبها بنفسي',
  questions_answer_placeholder: 'اكتب إجابتك…',
  close_conversation_title: 'إغلاق المحادثة',
  close_conversation_description: 'هل أنت متأكد أنك تريد إغلاق هذه المحادثة؟',
  close_conversation_cancel: 'لا',
  close_conversation_confirm: 'نعم',
  dialog_close: 'إغلاق',
  zoom_in: 'تكبير',
  zoom_out: 'تصغير',
  reset_zoom: 'إعادة تعيين التكبير',
  support_chat_aria_label: 'دردشة الدعم',
};
